import * as React from 'react';
import PropTypes from 'prop-types';

/**
 * SceneSlides
 *
 * Ref is forwarded
 */

const SceneSlides = React.forwardRef(({ children, tag, align, length, layout }, ref) => {
  const Tag = tag || 'div';
  const layoutClass = layout ? `l-${layout}` : '';
  const alignClass = align ? `align-${align}` : 'align-top';
  return (
    <Tag ref={ref} className={`scene-slides ${alignClass} ${layoutClass}`} style={{ '--slide-count': length }}>
      {children}
    </Tag>
  );
});

SceneSlides.displayName = 'SceneSlides';

SceneSlides.propTypes = {
  children: PropTypes.node.isRequired,
  tag: PropTypes.string,
  align: PropTypes.oneOfType([PropTypes.oneOf(['top', 'center', 'bottom']), PropTypes.bool]),
  length: PropTypes.number.isRequired,
  layout: PropTypes.string,
};

export default SceneSlides;
